const Seasons = {
  Spring: {
    name: 'Spring',
    icon: 'tree',
    phrase: 'Hurry let go to park and see the beauty.',
    bgColor: 'rgb(207, 243, 152)',
  },
  Summer: {
    name: 'Summer',
    icon: 'sun',
    phrase: "Let's hit the pool.",
    bgColor: 'rgb(252, 159, 136)',
  },
  Autumn: {
    name: 'Autumn',
    icon: 'leaf',
    phrase: 'Leaves are falling but new will born.',
    bgColor: 'rgb(252, 252, 178)',
  },
  Winter: {
    name: 'Winter',
    icon: 'snowflake',
    phrase: "Burrr! It' very cold outside.",
    bgColor: 'aliceblue',
  },
};

export default Seasons;
